import styled from 'styled-components/macro';

export const AIAssistantCardWrapper = styled.div<{ default?: boolean }>`
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(33% - 24px);
  max-width: 320px;
  height: 100%;
  max-height: 417px;
  gap: 20px;
  opacity: 1;
  padding: 20px;
  box-shadow:
    0px 6px 12px 0px rgba(66, 79, 104, 0.06),
    0px 0px 4px 0px rgba(66, 79, 104, 0.08);

  background: ${props => props.theme.colors.white[100]};
  border: ${props =>
    props.default
      ? `1px solid ${props.theme.colors.primary[100]}`
      : `1px solid ${props.theme.colors.neutral[20]}`};
`;

export const Content = styled.div`
  width: 100%;
  & .tab-container {
    max-width: 100%;
  }
  & .tab-navigation {
    padding: 0;
    justify-content: flex-start;
    max-width: 100%;
  }
  & .tab {
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
  }
  & .tab-content {
    padding: 27px 0 0 0;
    width: 100%;
  }
`;

export const AIAssistantName = styled.div`
  color: ${props => props.theme.colors.neutral[100]};
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;

  width: 100%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AIAssistantTitle = styled.div`
  color: ${props => props.theme.colors.neutral[100]};
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;

  width: 100%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AIAssistantDesription = styled.div`
  color: ${props => props.theme.colors.neutral[100]};
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0px;
  height: 48px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  word-break: break-word;
  width: 100%;
  min-width: 0;
`;
